"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataFromPartnerToken = exports.generateDocumentTokens = void 0;
const buffer_1 = require("buffer");
const generateDocumentTokens = (documentData, fields) => {
    const tokenSet = new Set();
    (fields || []).forEach((field) => {
        var _a;
        // @ts-ignore
        (_a = documentData[field]) === null || _a === void 0 ? void 0 : _a.split(/(?:-| )+/).forEach((word) => addUniqueWordTokens(word, tokenSet));
    });
    return Array.from(tokenSet);
};
exports.generateDocumentTokens = generateDocumentTokens;
const addUniqueWordTokens = (word, tokenSet) => {
    word = word.toLowerCase();
    for (let i = 0; i <= word.length; i++) {
        tokenSet.add(word.slice(0, i + 1));
    }
};
const getDataFromPartnerToken = (token) => {
    let decoded = null;
    let fullName = null;
    let email = null;
    let phone = null;
    let hasError = false;
    try {
        decoded = JSON.parse(buffer_1.Buffer.from(token, 'base64').toString());
        fullName = [decoded === null || decoded === void 0 ? void 0 : decoded.first_name, decoded === null || decoded === void 0 ? void 0 : decoded.last_name].join(' ');
        email = decoded === null || decoded === void 0 ? void 0 : decoded.email;
        phone = decoded === null || decoded === void 0 ? void 0 : decoded.phone;
    }
    catch (e) {
        hasError = true;
    }
    return { fullName, email, phone, hasError };
};
exports.getDataFromPartnerToken = getDataFromPartnerToken;
//# sourceMappingURL=tokens.js.map